import React from 'react';
import { LogEntry } from '../../../types/wordpress.type';

interface EventItemProps {
  event: LogEntry;
}

const EventItem: React.FC<EventItemProps> = ({ event }) => {
  const getSeverityConfig = () => {
    switch (event.severity) {
      case 'SUCCESS':
        return {
          bgColor: 'bg-green-50',
          borderColor: 'border-green-200',
          textColor: 'text-green-700',
          labelColor: 'text-green-600',
          icon: '✓',
        };
      case 'INFO':
        return {
          bgColor: 'bg-blue-50',
          borderColor: 'border-blue-200',
          textColor: 'text-blue-700',
          labelColor: 'text-blue-600',
          icon: 'ℹ',
        };
      case 'WARN':
        return {
          bgColor: 'bg-yellow-50',
          borderColor: 'border-yellow-200',
          textColor: 'text-yellow-700',
          labelColor: 'text-yellow-600',
          icon: '⚠',
        };
      case 'ERROR':
        return {
          bgColor: 'bg-red-50',
          borderColor: 'border-red-200',
          textColor: 'text-red-700',
          labelColor: 'text-red-600',
          icon: '✕',
        };
    }
  };

  const config = getSeverityConfig();

  const formatTime = (date: Date): string => {
    return date.toLocaleTimeString('en-US', {
      hour12: false,
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
    });
  };

  return (
    <div
      className={`${config.bgColor} border ${config.borderColor} rounded-lg p-3 mb-2 hover:shadow-sm transition-shadow`}
    >
      <div className="flex items-start gap-3">
        <span className={`${config.labelColor} font-bold text-sm flex-shrink-0`}>
          {config.icon}
        </span>
        <div className="flex-1 min-w-0">
          <div className="flex items-center gap-2 mb-1">
            <span className="text-xs font-mono text-gray-500 dark:text-gray-400 flex-shrink-0">
              {formatTime(event.timestamp)}
            </span>
            <span className={`text-xs font-bold ${config.labelColor} uppercase`}>
              {event.severity}
            </span>
          </div>
          <p className={`text-sm ${config.textColor} break-words`}>{event.message}</p>
          {event.category && (
            <span className="inline-block mt-1 text-xs text-gray-500 dark:text-gray-400 bg-white dark:bg-gray-800 px-2 py-0.5 rounded">
              {event.category}
            </span>
          )}
        </div>
      </div>
    </div>
  );
};

export default EventItem;